/** Chart.js v2 options — dark theme for Report charts */
export function getReportChartOptions() {
  return {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    legend: {
      display: true,
      labels: {
        fontColor: '#94a3b8',
        boxWidth: 12,
      },
    },
    tooltips: {
      enabled: true,
      mode: 'index',
      intersect: false,
      backgroundColor: '#1e2229',
      titleFontColor: '#f1f5f9',
      bodyFontColor: '#cbd5e1',
      borderColor: 'rgba(37, 139, 173, 0.4)',
      borderWidth: 1,
    },
    scales: {
      xAxes: [
        {
          barThickness: 10,
          maxBarThickness: 14,
          ticks: {
            fontColor: '#94a3b8',
          },
          gridLines: {
            color: 'rgba(255, 255, 255, 0.06)',
            drawBorder: false,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            fontColor: '#94a3b8',
            beginAtZero: true,
          },
          gridLines: {
            color: 'rgba(255, 255, 255, 0.06)',
            borderDash: [4, 4],
            drawBorder: false,
            zeroLineColor: 'rgba(255, 255, 255, 0.12)',
          },
        },
      ],
    },
  };
}

export const REPORT_CHART_COLORS = {
  stock: '#0a7290',
  option: '#38bdf8',
};
